module.exports = __webpack_public_path__ + "img/htit4.bbabbf23.png";